"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var ComboSelect = function (_a) {
    var items = _a.items, values = _a.values, onChange = _a.onChange, disabled = _a.disabled, disabledItems = _a.disabledItems, branding = _a.branding, className = _a.className, dataTestId = _a["data-testid"], ariaLabel = _a["aria-label"], _b = _a.orientation, orientation = _b === void 0 ? 'wrap' : _b, _c = _a.showIcon, showIcon = _c === void 0 ? true : _c;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateActiveColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    var selectedItems = (0, react_1.useMemo)(function () { return values; }, [values]);
    var _d = (0, react_1.useState)(), hover = _d[0], setHover = _d[1];
    var handleChange = (0, react_1.useCallback)(function (value) { return function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }; }, [onChange]);
    var handleMouseEnter = (0, react_1.useCallback)(function (key) { return function () {
        setHover(key);
    }; }, [setHover]);
    var handleMouseLeave = (0, react_1.useCallback)(function () {
        setHover(undefined);
    }, [setHover]);
    var renderIcon = function (key, selected, disabled) {
        if (!showIcon) {
            return null;
        }
        if (selected) {
            return ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: key === hover ? 'XCircle' : 'Check', size: "lg", fill: "primary" }));
        }
        return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "Plus", size: "lg", fill: disabled ? 'disabled' : 'base' });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "menu", "data-testid": dataTestId, "aria-label": ariaLabel, className: (0, classnames_1.default)('squid-flex squid-gap-component-combo-select-item-space-base', {
            'squid-flex-row': orientation === 'horizontal',
            'squid-flex-col': orientation === 'vertical',
            'squid-flex-row squid-flex-wrap': orientation === 'wrap',
        }, className) }, { children: items.map(function (item) {
            var _a;
            var selected = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(function (selectedItem) { return selectedItem.value || selectedItem.label; }).includes(item.value);
            var isDisabled = disabled || (disabledItems === null || disabledItems === void 0 ? void 0 : disabledItems.includes(item.value)) || !onChange;
            var borderColorClass = borderColors.base;
            if (selected) {
                borderColorClass = borderColors.active;
            }
            else if (item.value === hover) {
                borderColorClass = borderColors.hover;
            }
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": "".concat(dataTestId, "-item-").concat(item.label), onClick: isDisabled ? undefined : handleChange(item), onMouseEnter: selected ? handleMouseEnter(item.value) : undefined, onMouseLeave: selected ? handleMouseLeave : undefined, role: "menuitem", className: (0, classnames_1.default)("\n              squid-flex  \n              squid-flex-row \n              squid-bg-alias-color-bg-base\n              squid-items-center\n              squid-border-[1.5px] \n              squid-rounded-component-combo-select-item-border-radius-round \n              squid-px-component-combo-select-item-padding-horizontal\n              squid-py-component-combo-select-item-padding-vertical\n              squid-gap-alias-space-text-with-icon-md\n              ", selected ? bgStateColors.base : bgColors.base, !isDisabled ? 'squid-cursor-pointer' : undefined, orientation === 'vertical' ? 'squid-w-full' : 'squid-max-w-max', orientation === 'vertical'
                    ? 'squid-justify-between'
                    : 'squid-justify-center', borderColorClass, className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-gap-2" }, { children: [!!item.icon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: item.icon.name, variant: (_a = item.icon.variant) !== null && _a !== void 0 ? _a : 'outline', size: "lg", fill: selected ? 'primary' : isDisabled ? 'disabled' : 'base' })), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: true, as: "h6", size: "base", color: selected ? 'primary' : isDisabled ? 'disabled' : 'weaker', "data-testid": "".concat(dataTestId, "-item-").concat(item.label, "_label") }, { children: item.label }))] })), renderIcon(item.value, selected, isDisabled)] }), item.label));
        }) })));
};
exports.ComboSelect = ComboSelect;
